module.exports = __webpack_public_path__ + "static/media/student-impact-evaluation.62b8843a.svg";